import { Rule } from 'antd/es/form';
import Input from 'antd/es/input/Input';
import React from 'react';

import { formInputLength } from '../utils';
import { CardFormField } from './CardFormField';
import { SizeType } from 'antd/es/config-provider/SizeContext';

interface IProps {
  name: string;
  fieldLabel?: string;
  tooltip?: string;
  defaultValue?: string;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  onChange?: (value: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (value: React.SyntheticEvent) => void;
  placeholder?: string;
  disabled?: boolean;
  type?: string;
  validatePassword?: boolean;
  passwordConfirmation?: boolean;
  hasFeedback?: boolean;
  inputClassName?: string;
  fromItemClassName?: string;
  size?: SizeType;
  errorName?: string;
}

const CardFormInput: React.FC<IProps> = ({
  name,
  fieldLabel,
  tooltip,
  defaultValue,
  required = true,
  minLength = 0,
  maxLength = 60,
  onChange,
  onBlur = () => {},
  placeholder = '',
  disabled,
  type,
  validatePassword = true,
  passwordConfirmation = false,
  hasFeedback = false,
  inputClassName,
  fromItemClassName,
  size,
  errorName,
}) => {
  let customValidator;
  let customRules: Rule[] = [];

  if (maxLength) {
    customValidator = e => {
      return formInputLength(e.target.value, maxLength);
    };
    customRules.push({
      max: maxLength,
      message: `Limit of ${maxLength} characters exceeded`,
    });
  }
  if (minLength) {
    customRules.push({
      min: minLength,
      message: `Minimum required length is ${minLength}`,
    });
  }
  if (type === 'password' && validatePassword) {
    customRules.push({
      pattern: /^(?=.*[a-z]).*$/,
      message: `The password does not contain lowercase character`,
    });
    customRules.push({
      pattern: /^(?=.*[A-Z]).*$/,
      message: `The password does not contain uppercase character`,
    });
    customRules.push({
      pattern: /^(?=.*\d).*$/,
      message: `The password does not contain digit`,
    });
    if (passwordConfirmation) {
      customRules.push(({ getFieldValue }) => ({
        validator(_, value) {
          if (!value || getFieldValue('newPassword') === value) {
            return Promise.resolve();
          }
          return Promise.reject(
            new Error('Password confirmation does not match new password')
          );
        },
      }));
    }
  }
  if (name === 'code') {
    customRules.push({
      pattern: /^[0-9]{6,6}$/,
      message: `The code should have 6 digits`,
    });
    customRules.push({
      pattern: /^\d+$/,
      message: `The code should contain only digits`,
    });
  }
  if (name === 'email') {
    customRules.push({
      type: 'email',
      message: `This is not valid email`,
    });
  }

  return (
    <CardFormField
      name={name}
      fieldLabel={fieldLabel}
      tooltip={tooltip}
      boldLabel={true}
      defaultValue={defaultValue}
      customValidator={customValidator}
      customRules={customRules}
      required={required}
      hasFeedback={hasFeedback}
      className={fromItemClassName}
      errorName={errorName}
    >
      <Input
        value={defaultValue}
        minLength={minLength}
        maxLength={maxLength}
        onClick={event => event.stopPropagation}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        type={type}
        size={size ? size : 'middle'}
      />
    </CardFormField>
  );
};

export default CardFormInput;
